import React from 'react';

const HeroSection = () => {

  return (
    <div id="home" className="hero-container">
      <div className="hero-wrapper">
        <div className="hero-content">
        <h1 className="hero-title">
          A Million Problems -<br />
          <span className="highlight-text">One Solution</span>
        </h1>

        <p className="hero-subtitle">
          Introducing Infinitus 2.0, a single-stack Integrated Monitoring platform built to<br />
          deliver real-time decision intelligence.
        </p>

        <p className="hero-description">
          There's never a dearth of data. What we struggle with is the information and intelligence most relevant to the decisions we need to make. That's where Infinitus 2.0 changes the game. It transforms raw data into insight, enables proactive decisions, and turns monitoring into a true performance advantage, drawing your attention to information that matters most for your project's safety and success.
        </p>

        <button 
          className="know-more-btn"
          onClick={() => {
            const element = document.getElementById('how-it-works');
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }}
        >
          KNOW MORE
        </button>
      </div>
      </div>
    </div>
  );
};

export default HeroSection;
